/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useLayoutEffect, useRef } from "react";
import { useState } from "react";
import { Avatar, Dropdown, Badge, Tooltip, Input } from "antd";
import { EllipsisOutlined } from "@ant-design/icons";
import { Link, useNavigate, NavLink, useLocation } from "react-router-dom";
import { API_URL } from "../../helper/axioscontants";
import Logo from "../../assets/landingFeatures/qhrFlow.png";
import Notifications from "../../assets/notifications.svg";
import Settings from "../../assets/settings.svg";
import {
  DownOutlined,
  UserOutlined,
  EditOutlined,
  LogoutOutlined,
  FileOutlined,
  FormOutlined,
  AntDesignOutlined,
  SettingOutlined,
} from "@ant-design/icons";

import "./header.scss";
import useMembersStore from "../../store/members.store";
import useStatsStore from "../../store/stats.store";
import useAuthStore from "../../store/auth.store";
import { useGlobalStore } from "../../store/useGlobalStore";
import useSearchJDStore from "../../store/searchjd.store";
import useSettingstore from "../../store/settings.store";

const Header = () => {
  const { Search } = Input;
  const [toolTipOpen, setToolTipOpen] = useState(false);
  const [searchBarOpen, setSearchBarOpen] = useState(false);
  const [searchBarInput, setSearchBarInput] = useState("");
  const { unreadNotifications, markNotificationAsRead, checkProfilePicture  } = useStatsStore();
  const { getTeamMembers, teamMembers, currSubscription,checkSubscriptions } = useMembersStore();
  const {userLogout} = useAuthStore();
  const { clearSearchedJds } = useSearchJDStore();
  const {
    addOrUpdateSetting,
    removeSettingByKey,
    getSettingByKey,
    clearSettings,
  } = useSettingstore();
  const navigate = useNavigate();
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const [subscriptionIsActive, setSubscriptionIsActive] = useState(false);
  const location = useLocation();
  const navContainerRef = useRef(null);
  const [visibleCount, setVisibleCount] = useState(8);

  const persistedSearchInput = useSettingstore(
    (state) => state.settings?.find((s) => s.key === "searchInput")?.value,
  );

  const resetForcedLogoutFlag = useGlobalStore(
    (state) => state.resetForcedLogoutFlag
  );
  const forcedLogoutFlag = useGlobalStore((state) => state.forcedLogoutFlag);

  const getPermission = () => {
    if (
      userDetails.permission == "superuser" ||
      userDetails.permission == "superadmin" ||
      userDetails.permission == "admin"
    ) {
      return true;
    }
    return false;
  };
  const checkSub =() =>{
      if(userDetails?.permission === "superuser" ||
                     currSubscription === "trial_active" || currSubscription === "subscription_active"){
       setSubscriptionIsActive(true)
    }
  }
  useEffect(() => {
    resetForcedLogoutFlag();
    getTeamMembers();
    checkSubscriptions();
    const persistedSearchInput = getSettingByKey("searchInput")?.value;
    if (persistedSearchInput) {
      setSearchBarOpen(true);
      setSearchBarInput(persistedSearchInput);
    }
  }, []);

  useEffect(() => {
    checkSub()
  }, [currSubscription]);

  useEffect(() => {
    checkProfilePicture();
  }, []);

  useEffect(() => {
    const isSearchPage = location.pathname.includes("searchJd");
    if (isSearchPage) {
      setSearchBarOpen(false);
    }
    if (!isSearchPage) {
      setSearchBarInput("");
      setSearchBarOpen(false);
      clearSearchedJds();
    }
  }, [location.pathname]);

  useEffect(() => {
    const handleAwayStatus = () => {
      if (document.visibilityState === "hidden" && userDetails?.qhoid) {
        const url = `${API_URL}/session/activestatus/${userDetails.qhoid}/${userDetails.qhuid}/away`;

        // Use native fetch + keepalive to ensure it fires during tab close
        fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ _ignoreLoading: true }),
          keepalive: true,
        });
        localStorage.setItem("activestatus", "away");
      }
    };

    document.addEventListener("visibilitychange", handleAwayStatus);
    window.addEventListener("pagehide", handleAwayStatus);

    return () => {
      document.removeEventListener("visibilitychange", handleAwayStatus);
      window.removeEventListener("pagehide", handleAwayStatus);
    };
  }, []);

  var navigateTo = () => {
    navigate("/settings");
  };

  const handleLogOut = () => {
    clearSettings();
    userLogout();
    //localStorage.removeItem("userDetails");
    console.log("Navigating Home Initiated");
    navigate(`/home`);
  };

  useEffect(() => {
    if(forcedLogoutFlag){
        resetForcedLogoutFlag()
        //console.log("Logout Initiated")
        handleLogOut();        
    }
  }, [forcedLogoutFlag]);

  const activeStatus = localStorage.getItem("activestatus") || "online";

  const handleClickNewJD = () => {
    // Perform API call here with the selected option
    navigate(`/createJd`);
  };

  const handleProfile = () => {
        navigate(`/profile`);
  };

  const handleHelp = () => {
      if(userDetails.productsignon.toLowerCase().includes("qhrflow") === true){
           navigate(`/nujobsEmployerHelp`)
      }else{
            navigate(`/nujobsEmployerHelp`);
      }
    }      

  const handleTimeSheet = () => {
        navigate(`/timesheet`);
  };
    
      const handleAnalytics = () => {
        navigate(`/statsanalytics`);
      };

    const handleSubscriptions = () => {
      if(userDetails.productsignon.toLowerCase().includes("qhrflow") === false){
            navigate('/nujobsemployersuperadmin')
      }else{
        if(userDetails.permission == "superuser")
            navigate(`/superuser`)
        else if(userDetails.permission == "superadmin")
            navigate('/superadmin')
        else
            navigate('/usersubscription')
      }

      };      
  const allNavLinks = [
    { to: "/dashboard", label: "Home", end: true, public: true,nujobs: false,qhrflow: true,qhrset: false },
    { to: "/nujobsemployerdashboard", label: "Home", end: true, public: true,nujobs: true,qhrflow: false,qhrset: false },
    { to: "/qhrsetdashboard", label: "Home", end: true, public: true,nujobs: false,qhrflow: false,qhrset: true },    
    { to: "/resumes", label: "RDB Search", public: false ,nujobs: false,qhrflow: true,qhrset: false },
    { to: "/evalanalytics", label: "Eval Analytics", public: false,nujobs: false,qhrflow: true,qhrset: true  },
    { to: "/customers", label: "Clients", public: false,nujobs: true,qhrflow: true,qhrset: true  },
    { to: "/holidays", label: "Holidays", public: false,nujobs: false,qhrflow: true,qhrset: true  },
    { to: "/mytimeSheet", label: "Time Sheet", public: false,nujobs: false,qhrflow: true,qhrset: true  },
    { to: "/careersHome", label: "Careers", public: false, adminOnly: false ,nujobs: false,qhrflow: false,qhrset: false },
    { to: "/users", label: "Users", public: false, adminOnly: true,nujobs: true,qhrflow: true,qhrset: true },
  ];

  const checkProductType =(link) => {
    /*
    switch (userDetails.productsignon){
      case "nujobs": if(link.nujobs) return true
                     else return false
      case "qhrset": if(link.qhrset) return true
                     else return false
      case "qhrflow": if(link.qhrflow) return true
                      else return false
    }*/
    if( userDetails.productsignon.toLowerCase().includes("qhrflow")){
         if(link.qhrflow) return true
            else return false
    }
    if( userDetails.productsignon.toLowerCase().includes("nujobs")){
         if(link.nujobs) return true
            else return false
    }    
    return false
  }
  const allowedLinks = allNavLinks.filter((link) => {
    if (!subscriptionIsActive) return false;
    if (link.adminOnly) return getPermission();    
    if (checkProductType(link) == false) return false
    if (link.public) return true;
    return true;
  });
    const items = [
        {
            label: (
                <div className="e-mail">
                    {userDetails?.email}
                </div>
            ),
            key: "0",
        },        
        {
            label: (
                <div className="log-out" onClick={handleProfile}>
                    Profile
                </div>
            ),
            key: "1",
            icon: <UserOutlined />,
        },
        {
            label: (
                <div className="log-out" onClick={handleProfile}>
                    FAQ
                </div>
            ),
            key: "3",
            icon: <FileOutlined />,            
        },
        {
            label: (
                <div className="log-out" onClick={handleAnalytics}>
                    Analytics
                </div>
            ),
            key: "4",
            icon: <FormOutlined />,                  
        },
        {
            label: (
                <div className="log-out" onClick={handleSubscriptions}>
                    Subscriptions
                </div>
            ),
            key: "5",
            icon: <FormOutlined />,                  
        },
        {
            label: (
                <div className="log-out" onClick={handleHelp}>
                    Help
                </div>
            ),
            key: "6",
            icon: <FormOutlined />,                  
        },        
        {
            label: (
                <div className="log-out" onClick={handleLogOut}>
                    Logout
                </div>
            ),
            key: "7",
            icon: <LogoutOutlined />,
        },
    ];
    const itemsUsersAndAdmin = [
        {
            label: (
                <div className="e-mail">
                    {userDetails?.email}
                </div>
            ),
            key: "0",
        },        
        {
            label: (
                <div className="log-out" onClick={handleProfile}>
                    Profile
                </div>
            ),
            key: "1",
            icon: <UserOutlined />,
        },
        {
            label: (
                <div className="log-out" onClick={handleProfile}>
                    FAQ
                </div>
            ),
            key: "3",
            icon: <FileOutlined />,            
        },
        {
            label: (
                <div className="log-out" onClick={handleHelp}>
                    Help
                </div>
            ),
            key: "6",
            icon: <FormOutlined />,                  
        },        
        {
            label: (
                <div className="log-out" onClick={handleLogOut}>
                    Logout
                </div>
            ),
            key: "7",
            icon: <LogoutOutlined />,
        },
    ];  
    const itemsTimeSheet = [
        {
            label: (
                <div className="log-out" onClick={handleTimeSheet}>
                    TSL Config
                </div>
            ),
            key: "2",
            icon: <UserOutlined />,
        },        
    ];
    const itemsNuJobs = [
        {
            label: (
                <div className="e-mail">
                    {userDetails?.email}
                </div>
            ),
            key: "0",
        },        
        {
            label: (
                <div className="log-out" onClick={handleProfile}>
                    Profile
                </div>
            ),
            key: "1",
            icon: <UserOutlined />,
        },
        {
            label: (
                <div className="log-out" onClick={handleSubscriptions}>
                    Subscriptions
                </div>
            ),
            key: "2",
            icon: <FormOutlined />,                  
        },
        {
            label: (
                <div className="log-out" onClick={handleHelp}>
                    Help
                </div>
            ),
            key: "3",
            icon: <FormOutlined />,                  
        },        
        {
            label: (
                <div className="log-out" onClick={handleLogOut}>
                    Logout
                </div>
            ),
            key: "4",
            icon: <LogoutOutlined />,
        },
    ];
  function getDropDownItems() {
        var mArray, sorted
        if((userDetails.permission == "superuser") ||(userDetails.permission == "superadmin")){
            mArray = [...items,...(userDetails.tspermission == "Approvar" ? itemsTimeSheet : [])]
            sorted = [...mArray].sort((a, b) => Number(a.key) - Number(b.key));
            return sorted
        }else{
            mArray= [...itemsUsersAndAdmin,...(userDetails.tspermission == "Approvar"  ? itemsTimeSheet : [])]
            sorted = [...mArray].sort((a, b) => Number(a.key) - Number(b.key));
            return sorted
        }    
      };  
  function getNuJobsDropDownItems() {
        return itemsNuJobs   
      };        
  const colors = ["#f56a00", "#87d068", "#1890ff", "#ffc107", "#d32f2f"];

  const handleOpenChange = (visible) => {
    setToolTipOpen(visible); // updates on hover
  };

  const handleSearch = () => {
    navigate(`/searchJd`);
    const regex = /[^\s"']+|"([^"]*)"|'([^']*)'/g;
    const result = [];
    let match;

    while ((match = regex.exec(searchBarInput)) !== null) {
      // Index 1 is double quote match, Index 2 is single quote match, Index 0 is no quote match
      result.push(match[1] || match[2] || match[0]);
    }
    addOrUpdateSetting({ key: "searchInput", value: result });
  };

  const handleSearchClick = () => {
    if (persistedSearchInput) {
      navigate(`/searchJd`);
    } else {
      setSearchBarOpen(true);
    }
  };

  useLayoutEffect(() => {
    const handleResize = () => {
      if (!navContainerRef.current) return;

      const container = navContainerRef.current;
      // We target the individual link elements
      const children = Array.from(
        container.querySelectorAll(".links:not(.more-menu-trigger)"),
      );
      const containerWidth = container.getBoundingClientRect().width;

      // If the container hasn't rendered with width yet, don't hide everything
      if (containerWidth <= 0) return;

      let currentWidth = 0;
      let count = 0;
      const moreButtonWidth = 80; // Give the "More" button a bit more breathing room
      const gap = 36; // Matches the gap in your CSS

      for (let i = 0; i < allowedLinks.length; i++) {
        // Try to get the actual width of the rendered child if it exists,
        // otherwise estimate (approx 100px) for the first calculation
        const itemWidth = children[i]?.offsetWidth || 100;

        currentWidth += itemWidth + gap;

        // If adding this item exceeds width, stop here
        if (currentWidth + moreButtonWidth > containerWidth) {
          break;
        }
        count++;
      }

      // Safety check: always show at least the first item (Home)
      const finalCount = count === 0 ? 1 : count;

      // Only update state if the count actually changed to prevent render loops
      setVisibleCount((prev) => (prev !== finalCount ? finalCount : prev));
    };

    const observer = new ResizeObserver(() => {
      // Wrap in requestAnimationFrame to avoid "ResizeObserver loop limit exceeded" error
      window.requestAnimationFrame(handleResize);
    });

    if (navContainerRef.current) {
      observer.observe(navContainerRef.current);
      // Initial call to set correct state immediately
      handleResize();
    }

    return () => observer.disconnect();
  }, [allowedLinks]);

  const visibleNav = allowedLinks.slice(0, visibleCount);
  const hiddenNav = allowedLinks.slice(visibleCount);

  // Map hidden items for Ant Design Dropdown
  const moreItems = hiddenNav.map((link, idx) => ({
    key: `hidden-${idx}`,
    label: <Link to={link.to}>{link.label}</Link>,
  }));

  if (forcedLogoutFlag) return <></>;

  return (
        <nav className="navbar-wrapper">
      <div className="navbar-wrapper-left">
        <div className="logo-wrapper">
          QUALLYHIRE AI
        </div>
        <div
          className="services-links-wrapper"
          ref={navContainerRef}
          style={{
            flex: 1,
            display: "flex",
            overflow: "hidden",
            whiteSpace: "nowrap",
          }}
        >
          {visibleNav.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.end}
              className={({ isActive }) =>
                `links ${isActive ? "active-links" : ""}`
              }
            >
              {link.label}
            </NavLink>
          ))}

          {hiddenNav.length > 0 && (
            <Dropdown menu={{ items: moreItems }} trigger={["hover"]}>
              <a
                className="links more-menu-trigger"
                onClick={(e) => e.preventDefault()}
              >
                More <DownOutlined style={{ fontSize: "10px" }} />
              </a>
            </Dropdown>
          )}
        </div>
      </div>
      <div className="info-wrapper">
        <Avatar.Group
          max={{
            count: 3,
            style: {
              color: "#f56a00",
              backgroundColor: "#fde3cf",
            },
          }}
        >
          {teamMembers
            ?.filter(
              (member) =>
                member.signinstatus === "signin_status_signin" &&
                member.username !== userDetails.username
            )
            .map((member, index) => {
            const bgColor = colors[index % colors.length];

            return (
              <Tooltip
                title={
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      margin: "10px",
                      gap: "8px",
                    }}
                  >
                    <Avatar
                      style={{
                        backgroundColor: bgColor,
                      }}
                    >
                      {member?.username[0]}
                    </Avatar>
                      <div>
                        <p style={{ marginBottom: "0px" }}>
                          {member?.username}
                        </p>
                        <p style={{ marginBottom: "5px" }}>{member?.email}</p>
                      </div>
                    </div>
                }
                placement="bottom"
                color="white"
                overlayInnerStyle={{
                    color: "black",
                    fontWeight: "bold",
                }}
              >
                  <Badge
                    dot={true}
                    color={
                      member?.presencestatus === "online"
                        ? "#00A67E"
                        : "#FFDE21"
                    }
                    offset={[-7, 2]}
                  >
                    <Avatar
                      style={{
                        backgroundColor: bgColor,
                      }}
                    >
                      {member?.username[0]}
                    </Avatar>
                  </Badge>
                </Tooltip>
              );
            })}
        </Avatar.Group>
      </div>
      <div className="info-wrapper_1">
        {
          userDetails.productsignon.toLowerCase().includes("qhrflow") ? 
          <>
            <Tooltip
              placement="bottom"
              title={
                subscriptionIsActive ? "" : "Please activate your subscription"
              }
            >
              <button
                disabled={!subscriptionIsActive}
                onClick={handleClickNewJD}
                className="btn-header"
                style={{
                  backgroundColor: subscriptionIsActive ? "" : "lightgrey",
                  color: subscriptionIsActive ? "black" : "grey",
                  marginLeft: "80px",
                }}
              >
                + New JD
              </button>
            </Tooltip>          
          </>
          :<></>
        }


        {searchBarOpen ? (
          <Search
            placeholder="Search JDs"
            value={searchBarInput}
            onChange={(e) => setSearchBarInput(e.target.value)}
            onSearch={handleSearch}
            style={{ width: 200 }}
            enterButton
          />
        ) : (
          <button
            disabled={!subscriptionIsActive}
            onClick={handleSearchClick}
            className="btn-header"
            style={{
              backgroundColor: subscriptionIsActive ? "" : "lightgrey",
              color: subscriptionIsActive ? "black" : "grey",
            }}
          >
            Search JD
          </button>
        )}

        <Badge
          className="info-logo"
          size="small"
          count={unreadNotifications > 0 ? unreadNotifications : ""}
        >
          <img
            src={Notifications}
            alt="Notifications"
            onClick={() => {
              navigate("/notifications");
              markNotificationAsRead();
            }}
          />
        </Badge>
        <Dropdown
          menu={{items:  userDetails.productsignon.toLowerCase().includes("qhrflow")?getDropDownItems():getNuJobsDropDownItems()}}
          trigger={["click"]}
          onClick={() => setToolTipOpen(false)}
        >
          <Tooltip
            open={toolTipOpen}
            onOpenChange={handleOpenChange}
            title={
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  margin: "10px",
                  gap: "8px",
                }}
              >
                <Avatar
                  style={{
                    backgroundColor: " #008fff",
                  }}
                >
                  {userDetails?.username[0]}
                </Avatar>
                <div>
                  <p style={{ marginBottom: "0px" }}>{userDetails?.username}</p>
                  <p style={{ marginBottom: "5px" }}>{userDetails?.email}</p>
                </div>
              </div>
            }
            placement="bottomRight"
            color="white"
            overlayInnerStyle={{
              color: "black",
              fontWeight: "bold",
              maxWidth: "max-content", // ✅ correct place for this
              whiteSpace: "nowrap",
              width: "300px",
            }}
          >
            <Badge
              dot={true}
              color={activeStatus === "online" ? "#00A67E" : "#FFDE21"}
              offset={[-7, 2]}
            >
              <Avatar className="user-avatar">{userDetails.username[0]}</Avatar>
            </Badge>
          </Tooltip>
        </Dropdown>
      </div>
    </nav>
  );
};

export default Header;
